import { DialogComponent, dialogTemplate } from './Dialog';
import styles from './Dialog.styles.scss';
export const dialogDefinition = { baseName: 'dialog', template: dialogTemplate, styles };
export const chameleonDialog = DialogComponent.compose(dialogDefinition);
